import React, { useState } from 'react';
import { Logo, Button, Icon } from '../components/UI';
import { useApp } from '../context/AppContext';

export default function ResetPasswordPage() {
  const { updatePassword } = useApp();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (password.length < 6) { setError('Password must be at least 6 characters.'); return; }
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    setLoading(true);
    setError('');
    try {
      await updatePassword(password);
    } catch {
      setError('Could not update your password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bone)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 40, fontFamily: 'var(--font-body)' }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        <div style={{ marginBottom: 32, display: 'flex', justifyContent: 'center' }}>
          <Logo size="lg" />
        </div>
        <h1 style={{ fontFamily: 'var(--font-heading)', fontSize: 26, fontWeight: 800, color: 'var(--dark)', margin: '0 0 6px', letterSpacing: '-0.02em', textAlign: 'center' }}>Set a new password</h1>
        <p style={{ fontSize: 14, color: 'var(--dark-60)', margin: '0 0 32px', textAlign: 'center' }}>Choose a new password for your account.</p>

        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', fontFamily: 'var(--font-heading)', fontSize: 13, fontWeight: 600, color: 'var(--dark-80)', marginBottom: 6 }}>New password</label>
          <input
            type="password" value={password} onChange={e => setPassword(e.target.value)}
            placeholder="At least 6 characters"
            onKeyDown={e => e.key === 'Enter' && handleSubmit()}
            style={{ width: '100%', padding: '11px 14px', border: '1.5px solid var(--dark-20)', borderRadius: 'var(--radius-md)', fontSize: 14, outline: 'none', background: 'white' }}
            onFocus={e => e.target.style.borderColor = 'var(--orange)'}
            onBlur={e => e.target.style.borderColor = 'var(--dark-20)'}
          />
        </div>

        <div style={{ marginBottom: 20 }}>
          <label style={{ display: 'block', fontFamily: 'var(--font-heading)', fontSize: 13, fontWeight: 600, color: 'var(--dark-80)', marginBottom: 6 }}>Confirm password</label>
          <input
            type="password" value={confirm} onChange={e => setConfirm(e.target.value)}
            placeholder="Re-enter your new password"
            onKeyDown={e => e.key === 'Enter' && handleSubmit()}
            style={{ width: '100%', padding: '11px 14px', border: '1.5px solid var(--dark-20)', borderRadius: 'var(--radius-md)', fontSize: 14, outline: 'none', background: 'white' }}
            onFocus={e => e.target.style.borderColor = 'var(--orange)'}
            onBlur={e => e.target.style.borderColor = 'var(--dark-20)'}
          />
        </div>

        {error && (
          <div style={{ background: 'var(--danger-soft)', border: '1px solid rgba(214,69,69,0.2)', borderRadius: 'var(--radius-md)', padding: '10px 14px', marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
            <Icon name="alert" size={15} color="var(--danger)" />
            <p style={{ color: 'var(--danger)', fontSize: 13, margin: 0 }}>{error}</p>
          </div>
        )}

        <Button onClick={handleSubmit} fullWidth disabled={loading} size="lg" style={{ justifyContent: 'center' }}>
          {loading ? 'Updating…' : 'Update password'}
        </Button>
      </div>
    </div>
  );
}
